var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{staticClass:"ml-8",attrs:{"to":"/search"}},[_c('k-icon',{attrs:{"size":"27","color":_vm.showDarkHeader ? 'white' : 'brand-dark-blue'}},[_vm._v("\n    searchSkinny\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }